import { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext(['USD', () => {}]);

export function CurrencyProvider({ children }) {
	const [currency, setCurrency] = useState('USD');

	return (
		<CurrencyContext.Provider value={[currency, setCurrency]}>
			{children}
		</CurrencyContext.Provider>
	);
}

export const useCurrency = () => useContext(CurrencyContext);
